export const checkIsSSR = () => !!window?.isSSR;
